import React, { useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";

import appLogo from "../../assets/logo/applogo.png";
import { useAppPreferences } from "../../context/AppPreferencesContext";
import { getCurrentUser } from "../../utils/auth";

function joinClasses(...classes) {
  return classes.filter(Boolean).join(" ");
}

function matchesPath(pathname, prefixes = []) {
  return prefixes.some((prefix) => pathname.startsWith(prefix));
}

// Icons
function DashboardIcon() {
  return (
    <svg viewBox="0 0 24 24" className="ac-navsvg" aria-hidden="true">
      <path
        d="M4 10.5L12 4l8 6.5"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.5 9.5V19h11V9.5"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 19v-5h4v5"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function UsersIcon() {
  return (
    <svg viewBox="0 0 24 24" className="ac-navsvg" aria-hidden="true">
      <circle
        cx="9"
        cy="9"
        r="3"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
      />
      <circle
        cx="16.5"
        cy="10"
        r="2.5"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
      />
      <path
        d="M4.5 18c.9-2.7 3-4 5.5-4s4.6 1.3 5.5 4"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
      <path
        d="M14.5 17.5c.6-1.8 2-2.8 4-2.8 1 0 1.8.2 2.5.7"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
    </svg>
  );
}

function ContentIcon() {
  return (
    <svg viewBox="0 0 24 24" className="ac-navsvg" aria-hidden="true">
      <path
        d="M7 4.5h7l4 4V19a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 6 19V6A1.5 1.5 0 0 1 7.5 4.5Z"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinejoin="round"
      />
      <path
        d="M14 4.5V9h4"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinejoin="round"
      />
      <path
        d="M9 13h6M9 16h4"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
    </svg>
  );
}

function StatsIcon() {
  return (
    <svg viewBox="0 0 24 24" className="ac-navsvg" aria-hidden="true">
      <path
        d="M5 18.5h14"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
      <path
        d="M7.5 16V12.5"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
      <path
        d="M12 16V9"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
      <path
        d="M16.5 16V6.5"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
    </svg>
  );
}

function BellIcon() {
  return (
    <svg viewBox="0 0 24 24" className="ac-navsvg" aria-hidden="true">
      <path
        d="M12 4.5a4 4 0 0 1 4 4v2.2c0 1 .3 2 .9 2.8l1 1.4c.5.8 0 1.9-1 1.9H7.1c-1 0-1.5-1.1-1-1.9l1-1.4c.6-.8.9-1.8.9-2.8V8.5a4 4 0 0 1 4-4Z"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinejoin="round"
      />
      <path
        d="M10 18.5a2.2 2.2 0 0 0 4 0"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
    </svg>
  );
}

function FeedbackIcon() {
  return (
    <svg viewBox="0 0 24 24" className="ac-navsvg" aria-hidden="true">
      <path
        d="M6.5 7h11A2.5 2.5 0 0 1 20 9.5v4A2.5 2.5 0 0 1 17.5 16H12l-3.8 2.8c-.7.5-1.7 0-1.7-.9V16H6.5A2.5 2.5 0 0 1 4 13.5v-4A2.5 2.5 0 0 1 6.5 7Z"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function SettingsIcon() {
  return (
    <svg viewBox="0 0 24 24" className="ac-navsvg" aria-hidden="true">
      <path
        d="M12 8.5A3.5 3.5 0 1 1 12 15.5A3.5 3.5 0 0 1 12 8.5Z"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
      />
      <path
        d="M19 12a7.8 7.8 0 0 0-.1-1l2-1.6-2-3.4-2.5 1a8.8 8.8 0 0 0-1.7-1L14.4 3h-4.8l-.3 2.9a8.8 8.8 0 0 0-1.7 1l-2.5-1-2 3.4 2 1.6a7.8 7.8 0 0 0 0 2.1l-2 1.6 2 3.4 2.5-1a8.8 8.8 0 0 0 1.7 1l.3 2.9h4.8l.3-2.9a8.8 8.8 0 0 0 1.7-1l2.5 1 2-3.4-2-1.6c.1-.3.1-.7.1-1Z"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function LogoutIcon() {
  return (
    <svg viewBox="0 0 24 24" className="ac-navsvg" aria-hidden="true">
      <path
        d="M10 6H7.8A1.8 1.8 0 0 0 6 7.8v8.4A1.8 1.8 0 0 0 7.8 18H10"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
      <path
        d="M13 8l4 4-4 4"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 12h8"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
    </svg>
  );
}

function ChevronIcon({ open = false }) {
  return (
    <svg
      viewBox="0 0 24 24"
      className={joinClasses("ac-subnav-chevron", open && "is-open")}
      aria-hidden="true"
    >
      <path
        d="M9 6l6 6-6 6"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

const NAV_ICONS = {
  "/dashboard": <DashboardIcon />,
  "/stats": <StatsIcon />,
  "/feedback": <FeedbackIcon />,
  "/settings": <SettingsIcon />,
};

function Item({ to, label, collapsed, onNavigate }) {
  return (
    <NavLink
      to={to}
      onClick={onNavigate}
      title={collapsed ? label : undefined}
      className={({ isActive }) =>
        joinClasses(
          "ac-navitem",
          isActive && "is-active",
          collapsed && "is-collapsed"
        )
      }
    >
      <div className="ac-iconbox">{NAV_ICONS[to]}</div>
      {!collapsed && <span className="ac-navlabel">{label}</span>}
    </NavLink>
  );
}

function SubnavSection({
  collapsed,
  onNavigate,
  rootLabel,
  rootIcon,
  overviewLabel,
  overviewPath,
  overviewMatch = [],
  matchPrefixes = [],
  subItems = [],
}) {
  const location = useLocation();

  const isSectionActive = matchesPath(location.pathname, matchPrefixes);
  const isOverviewActive = overviewMatch.includes(location.pathname);

  const [open, setOpen] = useState(isSectionActive);

  useEffect(() => {
    if (isSectionActive) {
      setOpen(true);
    }
  }, [isSectionActive]);

  if (collapsed) {
    return (
      <NavLink
        to={overviewPath}
        onClick={onNavigate}
        title={rootLabel}
        className={() =>
          joinClasses("ac-navitem", isSectionActive && "is-active", "is-collapsed")
        }
      >
        <div className="ac-iconbox">{rootIcon}</div>
      </NavLink>
    );
  }

  return (
    <div className={joinClasses("ac-subnav-wrap", isSectionActive && "is-parent-active")}>
      <button
        type="button"
        onClick={() => setOpen((value) => !value)}
        className={joinClasses(
          "ac-navitem",
          "ac-subnav-trigger",
          isSectionActive && "is-active"
        )}
      >
        <div className="ac-iconbox">{rootIcon}</div>
        <span className="ac-navlabel">{rootLabel}</span>

        <span className="ac-subnav-arrow">
          <ChevronIcon open={open} />
        </span>
      </button>

      {open && (
        <div className="ac-subnav-list">
          <NavLink
            to={overviewPath}
            onClick={onNavigate}
            className={joinClasses("ac-subnav-item", isOverviewActive && "is-active")}
          >
            {overviewLabel}
          </NavLink>

          {subItems.map((item) => {
            const isItemActive = matchesPath(location.pathname, item.matchPrefixes);

            return (
              <NavLink
                key={item.to}
                to={item.to}
                onClick={onNavigate}
                className={joinClasses("ac-subnav-item", isItemActive && "is-active")}
              >
                {item.label}
              </NavLink>
            );
          })}
        </div>
      )}
    </div>
  );
}

export default function Sidebar({
  collapsed = false,
  mobileOpen = false,
  onCloseMobile,
  onRequestLogout = () => {},
}) {
  const { t } = useAppPreferences();
  const currentUser = getCurrentUser();

  const role = String(currentUser?.role || "admin").toLowerCase();
  const isAdmin = role === "admin";
  const isTeacher = role === "teacher";
  const isViewer = role === "viewer";
  const isScopedUser = isTeacher || isViewer;
  const canOpenSettings = isAdmin || isTeacher || isViewer;

  const handleNavigate = onCloseMobile;

  const usersClassesItems = [
    {
      to: "/users-classes/users",
      label: t("shell.users"),
      matchPrefixes: ["/users-classes/users"],
    },
    {
      to: "/users-classes/classes",
      label: t("shell.classes"),
      matchPrefixes: ["/users-classes/classes"],
    },
  ];

  const contentItems = [
    {
      to: "/content/tips",
      label: t("shell.tips"),
      matchPrefixes: ["/content/tips"],
    },
    {
      to: "/content/challenges",
      label: t("shell.challenges"),
      matchPrefixes: ["/content/challenges"],
    },
  ];

  const notificationItems = [
    {
      to: "/access-requests",
      label: "Zugangsanfragen",
      matchPrefixes: ["/access-requests"],
    },
    {
      to: "/rules",
      label: t("shell.rules"),
      matchPrefixes: ["/rules"],
    },
  ];

  return (
    <>
      <div
        aria-hidden="true"
        onClick={onCloseMobile}
        className={joinClasses("ac-sidebar-overlay", mobileOpen && "is-open")}
      />

      <aside
        className={joinClasses(
          "ac-sidebar",
          collapsed && "is-collapsed",
          mobileOpen && "is-mobile-open"
        )}
      >
        {/* Brand */}
        <div className="ac-brand">
          <div className="ac-brand-left">
            <div className="ac-brand-logoWrap">
              <img src={appLogo} alt="AceTime Logo" className="ac-brand-logo" />
            </div>

            {!collapsed && (
              <div className="ac-brand-copy">
                <div className="ac-brand-title">AceTime</div>
                <div className="ac-brand-admin">
                  {isAdmin ? t("shell.adminPanel") : "Lehrkraft-Zugang"}
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Navigation */}
        <nav className="ac-nav">
          <Item
            to="/dashboard"
            label={t("shell.dashboard")}
            collapsed={collapsed}
            onNavigate={handleNavigate}
          />

          <SubnavSection
            collapsed={collapsed}
            onNavigate={handleNavigate}
            rootLabel={t("shell.usersClasses")}
            rootIcon={<UsersIcon />}
            overviewLabel={t("shell.overview")}
            overviewPath="/users-classes"
            overviewMatch={["/users-classes"]}
            matchPrefixes={["/users-classes"]}
            subItems={usersClassesItems}
          />

          {isAdmin && (
            <SubnavSection
              collapsed={collapsed}
              onNavigate={handleNavigate}
              rootLabel={t("shell.content")}
              rootIcon={<ContentIcon />}
              overviewLabel={t("shell.overview")}
              overviewPath="/content"
              overviewMatch={["/content"]}
              matchPrefixes={["/content"]}
              subItems={contentItems}
            />
          )}

          <Item
            to="/stats"
            label={t("shell.stats")}
            collapsed={collapsed}
            onNavigate={handleNavigate}
          />

          {isAdmin && (
            <SubnavSection
              collapsed={collapsed}
              onNavigate={handleNavigate}
              rootLabel={t("shell.notifications")}
              rootIcon={<BellIcon />}
              overviewLabel={t("shell.overview")}
              overviewPath="/notifications"
              overviewMatch={["/notifications"]}
              matchPrefixes={["/notifications", "/rules", "/access-requests"]}
              subItems={notificationItems}
            />
          )}

          {isAdmin && (
            <Item
              to="/feedback"
              label={t("shell.feedback")}
              collapsed={collapsed}
              onNavigate={handleNavigate}
            />
          )}

          <div className="ac-divider" />

          {canOpenSettings && (
            <Item
              to="/settings"
              label={t("shell.settings")}
              collapsed={collapsed}
              onNavigate={handleNavigate}
            />
          )}

          {isScopedUser && !collapsed && (
            <div className="ac-side-note">
              <div className="ac-side-note-title">Eingeschränkter Zugriff</div>
              <div className="ac-side-note-text">
                Du siehst nur deine freigegebenen Klassenbereiche und kannst in
                den Einstellungen zusätzliche Klassen anfragen.
              </div>
            </div>
          )}
        </nav>

        {/* Footer */}
        <div className="ac-sidefooter">
          <button
            type="button"
            onClick={onRequestLogout}
            title={t("shell.logout")}
            className={joinClasses(
              "ac-sidefooter-action",
              collapsed && "is-collapsed"
            )}
          >
            <span className="ac-iconbox">
              <LogoutIcon />
            </span>

            {!collapsed && (
              <span className="ac-sidefooter-action-label">
                {t("shell.logout")}
              </span>
            )}
          </button>

          {!collapsed && (
            <div className="ac-footer-copy">
              Deine Zeit. Deine Balance. Dein Erfolg.
            </div>
          )}
        </div>
      </aside>
    </>
  );
}